import React from 'react';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { Link } from '../../../../../CommonComponents/OPL/Link/Link';
import { Modal } from '../../../../../CommonComponents/OPL/Modal/Modal';
import { ModalBody } from '../../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalCloseButton } from '../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalFooter } from '../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { ModalHeader } from '../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { IntegrationInfo } from '../IntegrationInfo/IntegrationInfo';
import { IntegrationDTO } from '../../api/useIntegrationsSettingsQuery';
import { Icon } from '../../../../../CommonComponents/OPL/Icon/Icon';

const website = 'https://www.tdameritrade.com/home.page';

interface Props {
  integration: IntegrationDTO;
  onClose(): void;
}

export const TDAmeritrade = ({ integration, onClose }: Props) => {
  return (
    <Modal isOpen onRequestClose={onClose} aria={{ labelledby: 'modal-header' }}>
      <ModalHeader as="h2" id="modal-header">
        {integration.Label}
      </ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <ModalBody>
        <IntegrationInfo integration={integration} website={website} />

        <Box display="flex" flexDirection="column" alignItems="center" css={{ gap: '8px' }} mt="16">
          <Text>
            To link your Schwab Institutional account with Orion Planning (such that all of your
            client accounts in custody at Schwab are automatically linked to the Orion Planning
            platform), take the following steps:
          </Text>

          <ol>
            <li>
              Fill out the{' '}
              <Link
                href="https://cdn2.hubspot.net/hubfs/2687807/Knowledge%20Hub/roi-advizr.pdf"
                target="_blank"
                rel="noreferrer noopener"
                isExternal
              >
                <Icon className="far fa-file-pdf" /> Third Party Release of Information - TD
              </Link>{' '}
              form.
            </li>
            <br />
            <li>
              Email the completed form to{' '}
              <Link href="mailto:zinstapipmsupport@tdameritrade.com?subject=Release of Information for Orion Planning.">
                zinstapipmsupport@tdameritrade.com
              </Link>{' '}
              .
            </li>
            <br />
            <li>
              Orion Planning will inform you via email when the integration is complete. Typical
              turnaround is 5-7 business days.
            </li>
          </ol>
        </Box>
      </ModalBody>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button ml="8" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};
